// extracted by mini-css-extract-plugin
module.exports = {"player":"_13rsK","player-loading":"YVzoe","playerLoading":"YVzoe"};